import React, { useEffect } from "react";

import NextLink from "next/link";

import { PostParsed } from "src/services/contentful/post/postParser";
import {
  IPageBlogPostFields,
  ISettingsFields,
} from "src/types/generated/contentful";
import {
  BackgroundOverlay,
  Bottom,
  BottomInner,
  Content,
  ContentInner,
  Meta,
  MetaInfo,
  ShareThisText,
  SocialContainer,
  SocialIconButton,
  SubTitle,
  Title,
  Wrapper,
} from "./styles";
import { Excerpt } from "src/components/atoms/TextBlock/styles";
import { Heading, IconButton, Link } from "@chakra-ui/react";
import { fixImagePath } from "src/utils/dom";
import { BlockRenderer } from "../BlockRenderer";
import ShareButtons from "@src/components/molecules/ShareButtons";

const postDateTemplate = {
  year: "numeric",
  month: "long",
  day: "numeric",
} as const;

export type PostHeaderProps = {
  post: PostParsed | { fields: IPageBlogPostFields } | undefined;
  settings: ISettingsFields;
};
const PostHeader: React.FC<any> = ({ post, settings, ...rest }) => {
  const seo = post?.fields?.seo;
  const seoImages = seo?.fields?.images;
  const author = post?.author || post?.fields?.content?.fields?.author;
  const slug = post?.slug || post?.fields?.slug;
  const postTitle = post?.title || post?.fields?.title;

  const postDescription = post?.excerpt || seo?.fields?.description;

  const postDate =
    post?.date || post?.fields?.pubDate || post?.fields?.content?.fields?.date;
  const tags = post?.tags || post?.metadata?.tags;
  const subTitle = post?.subtitle || post?.fields?.content?.fields?.subTitle;
  const excerpt = post?.excerpt || post?.fields?.content?.fields?.excerpt;

  const [imageUrl, setImageUrl] = React.useState<string | undefined>();
  const [authorName, setAuthorName] = React.useState<string | undefined>();
  const [blogOrArchive, setBlogOrArchive] = React.useState<
    string | undefined
  >();

  const shareButtonDefault = settings?.shareButtonDefault?.fields;

  useEffect(() => {
    setImageUrl(
      post?.coverImage?.url ||
        fixImagePath(
          post?.fields?.content?.fields?.coverImage?.fields?.file?.url
        )
    );
    setBlogOrArchive(seoImages ? "blog" : "blog");
  }, [
    post?.coverImage?.url,
    post?.fields?.content?.fields?.coverImage?.fields?.file?.url,
    seoImages,
    seoImages?.fields?.file?.url,
  ]);

  useEffect(() => {
    setAuthorName(post?.author?.name || author?.fields?.name);
  }, [author?.fields?.name, post?.author?.name]);

  return (
    <Wrapper {...rest} $src={imageUrl}>
      <Content>
        <ContentInner>
          <Heading
            as="h1"
            fontSize={["3xl", "3xl", "6xl"]}
            color="white"
            textAlign="center"
          >
            {postTitle}
          </Heading>

          {subTitle && (
            <Heading
              as="h2"
              fontFamily={"body"}
              fontSize={["sm", "md"]}
              fontWeight="normal"
              color="brandAccent.200"
              lineHeight="tall"
              pb={["2", "4"]}
              textAlign="center"
              pt="0"
              mt="0"
            >
              {subTitle}
            </Heading>
          )}
          <Meta>
            <MetaInfo>
              {author?.fields?.slug ? (
                <NextLink
                  href={`/team-member/${author?.fields?.slug}`}
                  passHref
                  legacyBehavior
                >
                  <Link>{authorName}</Link>
                </NextLink>
              ) : (
                authorName
              )}
            </MetaInfo>

            <MetaInfo>
              <time dateTime={postDate}>
                {new Date(postDate).toLocaleDateString(
                  "en-US",
                  postDateTemplate
                )}
              </time>
            </MetaInfo>
            {tags && tags.length > 0 && (
              <MetaInfo>
                {tags.map((e: any) => e?.name || e?.sys?.id).join(", ")}
              </MetaInfo>
            )}
          </Meta>
          {/*excerpt && <Excerpt>{excerpt}</Excerpt>*/}

        </ContentInner>

      </Content>
      <Bottom>
        <BottomInner>
          <ShareThisText>Share This Article</ShareThisText>

          <SocialContainer>
            <ShareButtons
              description={postDescription}
              title={postTitle}
              images={seoImages}
              slug={slug}
              theme="dark"
              data={settings?.shareButtonDefault}
            />
          </SocialContainer>
        </BottomInner>
      </Bottom>
      <BackgroundOverlay />

    </Wrapper>
  );
};

export default PostHeader;
